import WebviewManager from './lib/webview-manager';

export * from './lib/webview-manager.utils';
export * from './utils';

export const webviewManager = new WebviewManager();
